import { Link } from "react-router-dom";
import { executive } from "@/data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A1128] text-[#EEE9DF] mt-24"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="eyebrow eyebrow-inverse text-[#B89947]">Office of the President</div>
          <div className="h-editorial text-3xl md:text-4xl mt-4 text-white">
            {executive.name}
          </div>
          <div className="mt-2 text-sm text-[#C7C2B5] font-sans">
            {executive.title} · {executive.company}
          </div>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-[#C7C2B5] font-sans font-light">
            A capital advisory and business development firm supporting founders,
            executives, and institutional investors across private equity, consumer
            brands, retail, and manufacturing.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow eyebrow-inverse text-[#B89947]">Navigate</div>
          <ul className="mt-5 space-y-3 text-sm font-sans">
            <li><Link to="/leadership/biography" data-testid="footer-link-biography" className="text-[#EEE9DF] hover:text-[#B89947]">Executive Biography</Link></li>
            <li><Link to="/leadership/expertise" data-testid="footer-link-expertise" className="text-[#EEE9DF] hover:text-[#B89947]">Areas of Focus</Link></li>
            <li><Link to="/leadership/thought-leadership" data-testid="footer-link-thoughtleadership" className="text-[#EEE9DF] hover:text-[#B89947]">Thought Leadership</Link></li>
            <li><Link to="/leadership/media" data-testid="footer-link-media" className="text-[#EEE9DF] hover:text-[#B89947]">Media Center</Link></li>
            <li><Link to="/leadership/speaking" data-testid="footer-link-speaking" className="text-[#EEE9DF] hover:text-[#B89947]">Speaking Engagements</Link></li>
            <li><Link to="/leadership/contact" data-testid="footer-link-contact" className="text-[#EEE9DF] hover:text-[#B89947]">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow eyebrow-inverse text-[#B89947]">Office</div>
          <address className="mt-5 not-italic text-sm leading-relaxed text-[#C7C2B5] font-sans">
            {executive.address.streetAddress}<br />
            {executive.address.addressLocality}, {executive.address.addressRegion} {executive.address.postalCode}<br />
            {executive.address.addressCountry}
          </address>

          <div className="eyebrow eyebrow-inverse text-[#B89947] mt-8">Elsewhere</div>
          <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-sm font-sans">
            {executive.socials.map((s) => (
              <li key={s.label}>
                <a
                  href={s.url}
                  target="_blank"
                  rel="me noopener noreferrer"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="text-[#EEE9DF] hover:text-[#B89947] underline decoration-[#1E293B] underline-offset-4 hover:decoration-[#B89947]"
                >
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1E293B]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-xs text-[#8A8778] font-sans">
          <p>© {new Date().getFullYear()} Investors Pathway LLC. All rights reserved.</p>
          <p className="max-w-2xl md:text-right">
            This site is for informational purposes only and does not constitute an
            offer to sell, or a solicitation of an offer to buy, any securities or
            investment advisory services.
          </p>
        </div>
      </div>
    </footer>
  );
}
